
import { inject, observer } from 'mobx-react';
import DataGrid, { Paging, Column, Pager } from 'devextreme-react/data-grid';
import { useTranslation } from 'react-i18next'

const DataTable = inject("pictureStore")(observer((props) => {
  const { t } = useTranslation(['picture', 'common'])
  let { dataSource } = props // STATE
  let { onEdit } = props // ACTION

  return (<div className="">
    <DataGrid
      dataSource={dataSource}
      keyExpr="no"
      height="calc(100vh - 285px)"
      showBorders={true}
      columnAutoWidth={true}
      hoverStateEnabled={true}
    >
      <Paging defaultPageSize={20} />
      <Pager
        showInfo={true}
        showPageSizeSelector={true}
        allowedPageSizes={[10, 20, 50]}
      />
      <Column
        dataField="no"
        caption={t('no')}
        width={50}
        alignment="center"
      />
      <Column dataField="job_type_code" caption={t('job_type_code')} />
      <Column dataField="job_type_name" caption={t('job_type_name')} />
      <Column dataField="pic_count" caption={t('number_of_image')} />
      <Column
        fixed={true}
        caption={t('photo_settings')}
        type="buttons"
        width={120}
        buttons={[
          {
            hint: "แก้ไข",
            icon: "fa fa-pencil-square-o",
            visible: true,
            onClick: (e) => {
              e.cancel = "true"
              let data = e.row.data
              onEdit(data)
            }
          }
        ]} />

    </DataGrid>
  </div>
  )
}))

export default DataTable